import { episodeDetailsActionTypes } from '@/admin/pages/studyGoEpisodeDetails/Constants';

import type { EpisodeDetailsActions } from '@/admin/pages/studyGoEpisodeDetails/Actions';
import type { EpisodeDetailsState } from '@/admin/pages/studyGoEpisodeDetails/types';

const initialState: EpisodeDetailsState = {
	episode: null,
	loading: false,
	error: null,
};

export default function episodeDetailsReducer(
	state = initialState,
	action: EpisodeDetailsActions,
): EpisodeDetailsState {
	switch (action.type) {
		case episodeDetailsActionTypes.GET_EPISODE_DETAILS_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case episodeDetailsActionTypes.GET_EPISODE_DETAILS_SUCCESS:
			return {
				...state,
				loading: false,
				episode: action.payload.episode,
				error: null,
			};
		case episodeDetailsActionTypes.GET_EPISODE_DETAILS_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.error,
			};
		case episodeDetailsActionTypes.ADD_ROOM_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case episodeDetailsActionTypes.ADD_ROOM_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};
		case episodeDetailsActionTypes.ADD_ROOM_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.error,
			};
		case episodeDetailsActionTypes.ADD_HINT_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case episodeDetailsActionTypes.ADD_HINT_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};
		case episodeDetailsActionTypes.ADD_HINT_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.error,
			};
		case episodeDetailsActionTypes.UPDATE_ROOM_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case episodeDetailsActionTypes.UPDATE_ROOM_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};
		case episodeDetailsActionTypes.UPDATE_ROOM_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.error,
			};
		case episodeDetailsActionTypes.UPDATE_HINT_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case episodeDetailsActionTypes.UPDATE_HINT_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};
		case episodeDetailsActionTypes.UPDATE_HINT_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload.error,
			};
		case episodeDetailsActionTypes.CLEAN_EPISODE_DETAILS_STATE:
			return initialState;
		default:
			return state;
	}
}
